import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";
import BillableActivitiesListBody from "components/ClinicalManagement/BillableActivities/ListBody/BillableActivitiesListBody";

const BillableActivities = () => {
  useEffect(() => {
    document.title = "Billable Activities";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <BillableActivitiesListBody />
    </main>
  );
};

export default BillableActivities;
